import { useEffect, useState } from "react";

import ENV from '../app/constants/env';
import getObjectCommand from "../app/constants/utils";
import { isJsonString } from "../components/newHomePage/utils/newHomePageUtils";

const {
  HOMEPAGE_BUCKET_NAME,
  REACT_APP_ENVIORNMENT,
} = ENV;

export const streamToString = async (stream: ReadableStream) => {
  const steamResponse = new Response(stream);
  const res = await steamResponse.text();
  return res;
};

const useGetS3Data = <T,>({ onCompleted }: { onCompleted?: (data: T) => void }): { loading: boolean; error: unknown | null; data: T | null } => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown | null>(null);
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      setLoading(true);

      try {
        const key = REACT_APP_ENVIORNMENT === 'dev' ? 'home_dev.json' : 'home_prod.json';
        const s3Data = await getObjectCommand(HOMEPAGE_BUCKET_NAME, key);
        const sanitizedData = isJsonString(s3Data) ? JSON.parse(s3Data) : {};
        setData(sanitizedData);
        if (onCompleted) onCompleted(sanitizedData);
      } catch (e) {
        setError(e);
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  return { loading, error, data };
};

export default useGetS3Data;
